import actions from '@/store/modules/poDetails/actions';
import mutations from '@/store/modules/poDetails/mutations';
import PoDetails from '@/store/modules/poDetails/constants';
import PurchaseOrderLineStatus from '@/models/purchaseOrderLineStatus';

const state = {
  poNumber: '',
  clients: [],
  isMyClient: false,
  isMyEmployeeClient: false,
  currentGroupLineItemNumber: null,
  currentLineItemId: null,
  currentLineItemUploadedImages: [],
  currentLineItemApprovedImages: [],
  currentLineItemActivities: [],
  lineItems: [],
  groupedLineItems: [],
  loading: true,
  imagesUploading: false,
  approvedImagesLoading: false,
  uploadedImagesLoading: false,
  activityLoading: false,
  actionsDisabled: false,
  canAddComment: true,
  isAssignedToClient: false,
  searchResults: null,
};

// getters
const getters = {
  [PoDetails.getterTypes.currentLineItemInfo](localState) {
    const currentLineItem = localState.groupedLineItems
      .find((li) => li.itemNumber === localState.currentGroupLineItemNumber) || {};

    const lineItemInfo = {
      ...currentLineItem,
      uploadedImages: localState.currentLineItemUploadedImages,
      approvedImages: localState.currentLineItemApprovedImages,
      activities: localState.currentLineItemActivities,
    };

    return lineItemInfo;
  },
  [PoDetails.getterTypes.currentLineItemStatus](localState, localGetters) {
    const currentLineItem = localGetters[PoDetails.getterTypes.currentLineItemInfo];

    if (!currentLineItem.status) {
      return PurchaseOrderLineStatus.NotSubmitted.key;
    }

    return currentLineItem.status;
  },
  [PoDetails.getterTypes.currentLineItemImagesCount](localState, localGetters) {
    const currentLineItem = localGetters[PoDetails.getterTypes.currentLineItemInfo];

    if (!currentLineItem.images) {
      return 0;
    }

    return currentLineItem.images.length;
  },
  [PoDetails.getterTypes.currentLineInfoLoading](localState) {
    return localState.approvedImagesLoading
      || localState.uploadedImagesLoading
      || localState.activityLoading
      || localState.imagesUploading;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
